// eslint-disable-next-line
export const numericRegex = RegExp(`^(-?)(\d*(\.|\,)\d*)|(0?(\.|\,)?\d*)$`)
